import React from "react";
import { Check, X, Minus } from "lucide-react";

const ROWS = [
  { criteria: "Cost", aidify: "Affordable global rates", freelancer: "Unpredictable pricing", inhouse: "High salary + benefits + taxes", aidifyOk: true, freeOk: false, inOk: false },
  { criteria: "Availability", aidify: "Within 2 hours", freelancer: "Days to weeks", inhouse: "Weeks to months", aidifyOk: true, freeOk: false, inOk: false },
  { criteria: "US Accountability", aidify: "Named US partner", freelancer: "None", inhouse: "Direct but very expensive", aidifyOk: true, freeOk: false, inOk: false },
  { criteria: "Consistency", aidify: "Actively managed and monitored", freelancer: "Often inconsistent", inhouse: "Depends on the hire", aidifyOk: true, freeOk: false, inOk: false },
  { criteria: "Scalability", aidify: "Add support anytime", freelancer: "Start over each time", inhouse: "Lengthy hiring process", aidifyOk: true, freeOk: false, inOk: false },
  { criteria: "Tools Proficiency", aidify: "Pre-trained on your stack", freelancer: "Hit or miss", inhouse: "Requires training", aidifyOk: true, freeOk: false, inOk: false },
  { criteria: "Oversight", aidify: "24/7 US oversight", freelancer: "You manage everything", inhouse: "You manage everything", aidifyOk: true, freeOk: false, inOk: false },
  { criteria: "Risk", aidify: "Fully backed and managed", freelancer: "High drop-off & quality issues", inhouse: "Turnover risk", aidifyOk: true, freeOk: false, inOk: false },
];

function Mark({ status }) {
  if (status === true) return <Check size={16} className="text-sage-500" strokeWidth={3} />;
  if (status === false) return <X size={16} className="text-forest-400/60" strokeWidth={2.5} />;
  return <Minus size={16} className="text-forest-400/60" strokeWidth={2.5} />;
}

export default function ComparisonTable() {
  return (
    <div className="aidify-card overflow-hidden" data-testid="comparison-table">
      <div className="grid grid-cols-12 gap-2 px-6 py-4 text-xs uppercase tracking-[0.18em] text-forest-400/70 border-b border-forest-500/10">
        <div className="col-span-3">Criteria</div>
        <div className="col-span-3 bg-forest-600 -my-4 -mx-2 px-3 py-4 text-cream-100">
          <div className="font-display font-extrabold text-base normal-case tracking-normal text-cream-100">Aidify</div>
          <div className="text-[10px] text-sage-200 tracking-[0.2em]">RECOMMENDED</div>
        </div>
        <div className="col-span-3">Freelancer</div>
        <div className="col-span-3">In-House Hire</div>
      </div>
      {ROWS.map((r, i) => (
        <div key={i} className={`cmp-row grid grid-cols-12 gap-2 px-6 py-4 items-start border-b border-forest-500/5 last:border-0`}>
          <div className="col-span-3 text-sm font-medium text-forest-500">{r.criteria}</div>
          <div className="col-span-3 bg-forest-600/95 -my-4 -mx-2 px-3 py-4 text-cream-100 flex gap-2 items-start">
            <Check size={16} className="text-sage-200 mt-0.5 shrink-0" strokeWidth={3} />
            <span className="text-sm">{r.aidify}</span>
          </div>
          <div className="col-span-3 flex gap-2 items-start text-sm text-forest-400">
            <Mark status={r.freeOk} />
            <span>{r.freelancer}</span>
          </div>
          <div className="col-span-3 flex gap-2 items-start text-sm text-forest-400">
            <Mark status={r.inOk} />
            <span>{r.inhouse}</span>
          </div>
        </div>
      ))}
      {/* <div className="px-6 py-5 border-t border-forest-500/10 flex items-center justify-between gap-4 flex-wrap">
        <p className="text-sm text-forest-500">
          <span className="font-display font-bold">Still comparing options?</span>{" "}
          <span className="font-serif-italic text-base">One conversation will make this easy.</span>
        </p>
      </div> */}
    </div>
  );
}
